export const selectSearch = (state) => state.filters.search
export const selectRegion = (state) => state.filters.region
export const selectAllFilters = (state) => state.filters